import { connect } from 'react-redux';

import { AppState } from '../../app/state/AppState';
import { MapStateToProps } from '../../app/utils/ConnectUtils';
import { RootApp, RootAppOwnProps, RootAppStateProps } from './RootApp';

export const mapStateToProps: MapStateToProps<RootAppStateProps> = (state: AppState) => ({
    rootAdminUiState: state.rootAdminUiState
  });

export const RootAppStateConnector: React.ComponentClass<RootAppOwnProps> = connect(mapStateToProps)(RootApp);